<template>
  <div>

    <div v-if="view" class="col-md-8 col-md-offset-2">
      <h3 class="text-center">{{ computeCaption(fields_en['schedule'], $store.state.lang.value.toLowerCase()) }}</h3>
      <br>
      <div class="text-center flex fs-18">
        <button class="hover-color button-text" :class="!viewScheduled ? 'selected-color': ''"
                @click.stop.prevent="toggleView(false)">
          {{ computeCaption(fields_en['unscheduled'], $store.state.lang.value.toLowerCase()) }}
          <span class="fs-18 primary-color">({{ this.registrationsUnscheduled.length }})</span>
        </button>
        <p class="pl-6 primary-color fs-26"> | </p>
        <button class="ml-6 hover-color button-text" :class="viewScheduled ? 'selected-color': ''"
                @click.stop.prevent="toggleView(true)">
          {{ computeCaption(fields_en['scheduled'], $store.state.lang.value.toLowerCase()) }}
        </button>
      </div>
      <div class="general-active-section">
        <div class="result-container">
          <div
            v-for="items in !viewScheduled ? registrationsUnscheduled : registrationsScheduled"
            :key="items['confirmation_number']"
            class="pb-40 col-xs-offset-left-1 col-xs-offset-right-1"
          >
            <div class="row result bg-color p-10 rounded text-gray">
              <div class="col-md-12">
                <p class="text-big">
                  <span><b>{{ computeCaption(fields_en['name'], $store.state.lang.value.toLowerCase()) }}</b></span>
                  {{ ' ' + items['first_name'] + ' ' + items['last_name'] }}</p>
                <p class="text-big"><span><b>{{
                    computeCaption('Date Of Birth', $store.state.lang.value.toLowerCase())
                  }}:</b></span> {{ ' ' + items['date_of_birth'] }}</p>
              </div>
              <div class="col-md-12">
                <p class="text-small">
                  <span><b>{{ computeCaption(fields_en['confirmation_number'], $store.state.lang.value.toLowerCase()) }}</b></span>
                  {{ ' ' + items['confirmation_number'] }}</p>
              </div>

              <div class="col-md-12 line-middle">
                <div class="col-md-6">
                  <p class="text-end">
                    <span><b>{{ computeCaption(fields_en['client'], $store.state.lang.value.toLowerCase()) }}</b></span>
                    <br>
                    {{ ' ' + items['client_name'] }}</p>
                </div>
                <div class="col-md-6">
                  <p class="text-start">
                    <span><b>{{ computeCaption(fields_en['site'], $store.state.lang.value.toLowerCase()) }}</b></span>
                    <br>
                    {{ ' ' + items['client_site_name'] }}</p>
                </div>
                <div class="col-md-6">
                  <p class="text-end">
                    <span><b>{{ computeCaption(fields_en['physician'], $store.state.lang.value.toLowerCase()) }}</b></span>
                    <br>
                    {{ ' ' + items['physician'] }}</p>
                </div>
                <div class="col-md-6">
                  <p class="text-start" v-if="!viewScheduled">
                    <span><b>{{ computeCaption(fields_en['initial_schedule_date'], $store.state.lang.value.toLowerCase()) }}</b></span>
                    <br>
                    {{ ' ' + items['initial_scheduled_date'] }}</p>
                  <p class="text-start" v-else>
                    <span><b>{{ computeCaption(fields_en['scheduled_date'], $store.state.lang.value.toLowerCase()) }}</b></span>
                    <br>
                    {{ ' ' + items['scheduled_date'] + ' ' + items['scheduled_time'] }}</p>
                </div>
              </div>
              <div class="col-md-12" v-if="!viewScheduled">
                <button
                  v-if="items['selected'] === false"
                  class="btn btn-default btn-wd btn-primary"
                  v-on:click.stop.prevent="select(items)"
                ><span>{{ computeCaption(fields_en['schedule_button'], $store.state.lang.value.toLowerCase()) }}</span>
                </button
                >
                <button
                  v-if="items['selected'] === true"
                  class="btn btn-default btn-wd btn-back primary-color"
                  v-on:click.stop.prevent="unselect(items)"
                ><span>{{ computeCaption(fields_en['cancel'], $store.state.lang.value.toLowerCase()) }}</span></button
                >
              </div>
            </div>
            <div v-if="items['selected'] === true" class="row">
              <div style="padding: 0px 15px">
                <ScheduleSection v-if="$store.state.site.schedule.data.length" ref="ScheduleSection"></ScheduleSection>
              </div>
              <div class="text-center pt-15">
                <button
                  class="btn btn-default btn-wd btn-primary"
                  v-on:click.stop.prevent="updateSchedule(items['confirmation_number'])"
                >
                  <span>{{ computeCaption(fields_en['finish_appointment'], $store.state.lang.value.toLowerCase()) }}</span>
                </button
                >
              </div>
              <span class="text-danger">{{ errorData }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button
          class="btn btn-default btn-wd btn-back primary-color"
          v-on:click.stop.prevent="$router.push({ path: '/patient/account' })"
        ><span>{{ computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase()) }}</span></button
        >
      </div>
      <br><br>
    </div>
    <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>

<script>
import {mapFields} from 'vee-validate'
import axios from 'axios'
import {Button, Input, RadioGroup, Radio, RadioButton} from 'element-ui'
import {FormatterUtils} from '../../../../../utils/Formatter.js'
import {ValidationUtils} from '../../../../../utils/Validation.js'
import VueBarcode from 'vue-barcode'
import {TranslationsUtils} from '../../../../../utils/Translations'
import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
import ScheduleSection from '../../Utils/Sections/ScheduleSection'

export default {
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    'barcode': VueBarcode,
    ScheduleSection
  },
  mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils],
  data () {
    return {
      view: false,
      moreInfoButton: '',
      errorData: '',
      schedule: this.$store.state.site.schedule,
      registrationsScheduled: this.$store.state.registrationsScheduled,
      registrationsUnscheduled: this.$store.state.registrationsUnscheduled,
      loading: false,
      viewScheduled: false,
      model: {
        email: '',
        password: ''
      },
      fields_en: {
        scheduled: 'Scheduled',
        schedule_button: 'Schedule',
        unscheduled: 'To be scheduled',
        confirmation_number: 'Confirmation Number:',
        patient_name: 'Patient Name:',
        schedule: 'Schedule an appointment',
        back: 'Back',
        please_input_your_data: 'Please input your data',
        email: 'Email',
        password: 'Password',
        name: 'Name:',
        initial_schedule_date: 'Initial Schedule Date:',
        cancel: 'Cancel',
        finish_appointment: 'Finish Appointment',
        scheduled_date: 'Scheduled Date:',
        client: 'Client',
        site: 'Site',
        physician: 'Physician'
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          min: 8,
          required: true
        }
      }
    }
  },
  async beforeMount () {
    let one = process.env.SERVER_URI + '/account/get/registrations/unscheduled'
    let three = process.env.SERVER_URI + '/account/get/registrations/scheduled'
    let two = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
    const requestOne = axios.post(one, {'email': localStorage.getItem('email')}, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    const requestThree = axios.post(three, {'email': localStorage.getItem('email')}, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    const requestTwo = axios.get(two)
    await axios.all([requestOne, requestTwo, requestThree]).then(axios.spread((...responses) => {
      if (responses[1].data === false) {
        this.view = false
      } else {
        this.overwriteGraphSettings(responses[1].data)
        this.$store.state.site = responses[1].data
        this.schedule = responses[1].data.schedule
      }
      this.$store.state.registrationsUnscheduled = responses[0].data
      this.$store.state.registrationsScheduled = responses[2].data
      this.view = true
    })).catch(error => {
      console.log(error)
      this.view = false
    })
    this.registrationsScheduled = this.$store.state.registrationsScheduled
    this.registrationsUnscheduled = this.$store.state.registrationsUnscheduled
    if (!this.registrationsUnscheduled.length) {
      this.viewScheduled = true
    }
  },
  methods: {
    unselect (item) {
      item['selected'] = false
    },
    select (item) {
      item['selected'] = true
    },
    toggleView (booleanValue) {
      this.viewScheduled = booleanValue
    },
    changeTab (id) {
      if (this.moreInfoButton === id) {
        this.moreInfoButton = ''
      } else {
        this.moreInfoButton = id
      }
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    setLoading (value) {
      this.loading = value
    },
    async validate () {
      let ScheduleSection
      console.log(this.$refs.ScheduleSection[0])
      if (this.$store.state.site.schedule.data.length) {
        ScheduleSection = await this.$refs.ScheduleSection[0].validate()
      }
      return ScheduleSection
    },
    async updateSchedule (confirmationNumber) {
      let validation = await this.validate()
      this.errorData = ''
      if (validation) {
        let one = process.env.SERVER_URI + '/account/update/registrations/scheduled'
        let two = process.env.SERVER_URI + '/account/get/registrations/unscheduled'
        let three = process.env.SERVER_URI + '/account/get/registrations/scheduled'
        let four = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
        await axios.post(one, {
          'email': localStorage.getItem('email'),
          'schedule': validation,
          'confirmation_number': confirmationNumber
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }).then((response) => {
          if (response.data === false) {
            this.errorData = 'There were problems with submitting the data. Please try again'
          }
        })
        const requestTwo = axios.post(two, {'email': localStorage.getItem('email')}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const requestThree = axios.post(three, {'email': localStorage.getItem('email')}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        const requestFour = axios.get(four)
        if (this.errorData === '') {
          await axios.all([requestTwo, requestThree, requestFour]).then(axios.spread((...responses) => {
            if (responses[2].data === false) {
              this.view = false
            } else {
              this.overwriteGraphSettings(responses[2].data)
              this.$store.state.site = responses[2].data
              this.schedule = responses[2].data.schedule
            }
            this.$store.state.registrationsUnscheduled = responses[0].data
            this.$store.state.registrationsScheduled = responses[1].data
            this.view = true
          })).catch(error => {
            console.log(error)
            this.view = false
          })
        }
        this.registrationsScheduled = this.$store.state.registrationsScheduled
        this.registrationsUnscheduled = this.$store.state.registrationsUnscheduled
        if (!this.registrationsUnscheduled.length) {
          this.viewScheduled = true
        }
      } else {
        this.errorData = 'There were problems with submitting the data. Please try again'
      }
    }
  },
  computed: {
    ...mapFields(['email', 'password'])
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

.image {
  width: 30px;
  height: 30px;
  padding-top: 0%;
}

.button-text {
  border: none;
  background-color: white;
}

.hover-color:hover {
  color: $primary-color;
  border-bottom: 3px solid $primary-color;
}

.selected-color {
  background-color: #E8F0FE;
}

.el-select--large {
  width: 100%;
}

.approvedBG {
  background: #E8F0FE !important;
}

.turnGreen {
  color: $primary-color !important;
}

.bg-color {
  background-color: white;
}

.text-green {
  color: $primary-color;
}

.p-10 {
  padding-top: 8px;
  padding-bottom: 1px;
  padding-right: 3px;
  padding-left: 3px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pt-15 {
  padding-top: 15px;
}

.pt-4 {
  padding-top: 4px;
}

.pt-3 {
  padding-top: 3px;
}

.pt-6 {
  padding-top: 6px;
}

.pl-6 {
  padding-left: 6px;
}

.ml-6 {
  margin-left: 6px;
}

.ml-10 {
  margin-left: 10px;
}

.result {
  text-align: center;
  font-size: 20px;
}

.result-container {
  min-height: 600px;
}

.icon {
  color: $primary-color;
  font-size: 20px;
}

.icon-button {
  font-size: 40px;
}

.rounded {
  padding: 30px;
  border: 1px solid $default-grey;
  border-radius: 3px;
}

.fs-12 {
  font-size: 12px;
}

.fs-26 {
  font-size: 26px !important;
}

.fs-18 {
  font-size: 18px;
}

.ml-20 {
  margin-left: -20px;
}

.col-xs-offset-left-1 {
  margin-left: 8.33333333%;
}

.col-xs-offset-right-1 {
  margin-right: 8.33333333%;
}

.display-bigger-screen-none {
  display: none;
}

.text-right {
  float: right;
  margin-top: 20px;
  margin-bottom: 20px;
}

@media screen and (max-width: 990px) {
  .result-container {
    min-height: 650px;
  }
  .display-bigger-screen-none {
    display: block;
  }
  .display-mobile-none {
    display: none;
  }
  .float-mobile {
    float: right;
  }
  .fs-12 {
    padding-top: 15px;
  }
  .image {
    width: 30px;
    height: 30px;
    object-fit: contain;
    object-position: center;
  }
}

@media screen and (max-width: 450px) {
  .result-container {
    min-height: 750px;
  }

  .display-bigger-screen-none {
    display: block;
  }

  .icon-button {
    font-size: 35px;
  }

  .display-mobile-none {
    display: none;
  }

  .float-mobile {
    float: right;
  }
}

.fade-enter-active {
  transition: opacity 0.5s ease;
}

.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.text-big {
  font-size: 20px;
}

.text-small {
  font-size: 15px;
}

.text-gray {
  color: #4d4949;
}

.text-end {
  text-align: end;
}

.text-start {
  text-align: start;
}

.line-middle {
  position: relative;
  margin: 40px 0;

  &::before {
    position: absolute;
    content: '';
    height: 100%;
    width: 2px;
    background: #c4c4c4;
    margin: 0 auto;
    top: 0;
    left: 0;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/Schedule.vue